module.exports = __webpack_public_path__ + "img/calligraphy_yingbi.bb4acd49.png";